import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

interface EventOptionsListProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onQuote: () => void;
  canDelete?: boolean;
  onDelete?: () => void;
}

const EventOptionsList: React.FC<EventOptionsListProps> = ({
  anchorEl,
  onClose,
  canDelete,
  onDelete
}) => {
  const {t} = useTranslation();

  // const handleQuote = useCallback(() => {
  //   onQuote();
  //   onClose();
  // }, [onClose, onQuote]);

  const handleDeleteOptionClick = useCallback(() => {
    if (onDelete) {
      onDelete();
    }
    onClose();
  }, [onClose, onDelete]);

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {/* <MenuItem onClick={handleQuote}>{t('quote')}</MenuItem> */}

      {canDelete && (
        <MenuItem onClick={handleDeleteOptionClick}>{t('delete')}</MenuItem>
      )}
    </Menu>
  );
};

export default EventOptionsList;
